import React from 'react';
import { translate } from 'react-i18next';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import DatePicker from 'material-ui/DatePicker';
import compose from '../compose';
import user from '../Auth/user';

class DateRange extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      today: Date.now()
    };
  }

  render()  {
    const {t, user} = this.props;

    return (
      <div className='col-xs col-md-5'>
        <span className='headerSpanStyle'>
          {t('offer.disableDates')}
        </span>
        <RadioButtonGroup
          name={t('offer.disableDates')}
          valueSelected={this.props.disableDates}
          onChange={this.props.setDisableDates}>
          <RadioButton
            value={true}
            label={t('offer.always')}
            className='switchButton'
          />
          <RadioButton
            value={false}
            label={t('offer.betweenRange')}
            className='switchButton'
          />
        </RadioButtonGroup>
        <DatePicker
          textFieldStyle={{width: '150px', marginLeft: '50px'}}
          floatingLabelFixed={true}
          floatingLabelText={t('startRange')}
          cancelLabel={t('cancel')}
          locale={user.language}
          minDate={new Date(this.state.today)}
          maxDate={(this.props.endDate) ? new Date(this.props.endDate) : null}
          DateTimeFormat={Intl.DateTimeFormat}
          value={(this.props.startDate) ? new Date(this.props.startDate) : null}
          autoOk={true}
          onChange={this.props.handleStartDateChange}
          container='inline'
          disabled={this.props.disableDates}
        />
        <DatePicker
          textFieldStyle={{width: '150px', marginLeft: '50px'}}
          floatingLabelFixed={true}
          floatingLabelText={t('endRange')}
          cancelLabel={t('cancel')}
          locale={user.language}
          minDate={(this.props.startDate > this.state.today) ? new Date(this.props.startDate) : new Date(this.state.today)}
          DateTimeFormat={Intl.DateTimeFormat}
          value={(this.props.endDate) ? new Date(this.props.endDate) : null}
          autoOk={true}
          onChange={this.props.handleEndDateChange}
          container='inline'
          disabled={this.props.disableDates}
        />
        <div className='paddingDiv'/>
      </div>
    );
  }

}

const enhance = compose(translate(), user);

export default enhance(DateRange);



// WEBPACK FOOTER //
// ./src/Offer/DateRange.js